import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { grey } from '@mui/material/colors';
import { makeStyles } from "@material-ui/core/styles";
import Grid  from '@mui/material/Grid';
import Slide from '@mui/material/Slide';
const style = {

};

const SelectModal = (props) => {
  const containerRef = React.useRef(null);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [modalValue, setModalValue] = useState('');

  useEffect(() => {
    setOpen(props.visible);
    setModalValue('');
  }, [props.visible]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRadioChange = (event) => {
    setModalValue(event.target.value);
  };

  const handleSubmit = () => {
    if (modalValue) {
      let currentOptionObj = props.options.find((o) => o.value === modalValue);
      props.changeValue(currentOptionObj);
    }
    setOpen(false);
  };


  return (
    <Box>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Slide direction="up" in={open} container={containerRef.current}>
        <Box className={classes.Modal} sx={{}}>
          <Typography sx={{fontWeight: '800', fontSize: '1.4rem', mt:2, mx:2,'@media (min-width: 1636px)': {fontSize: '2rem'} }}>
            {props.title}
          </Typography>
          <hr />
          <RadioGroup          
            value={modalValue}
            onChange={handleRadioChange}
            sx={{mt:2, mx:2}}
          >
            {props.options &&
              props.options.map((data, ind) => {
                return (
                  <FormControlLabel value={data.value} control={<Radio sx={{color: grey[50],
                    '&.Mui-checked': {
                      color: grey[50],
                    },'@media (min-width: 1636px)': {my: 1} }} 
                    />} label={<Typography sx={{fontWeight: '500', fontSize: '0.9rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}>{data.text}</Typography>} />
                );
              })
            }
          </RadioGroup>
          <hr />
          <Grid item sx={{ textAlign: "center" }}>
            <Button onClick={handleSubmit} color="success" variant="contained"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            backgroundColor: "primary.success",
                            color: "#FFF",
                            fontWeight: "bold",
                            mt: 3,
                            px: 2,
                            '@media (min-width: 1636px)': {fontSize: '1.4rem'} 
                            
                          }}>
              Save
            </Button>
          </Grid>
          <Grid item sx={{ textAlign: "center" }}>
            <Button onClick={handleClose} variant="contained"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            border: 1,
                            borderColor: "#FFFFFF",
                            color: "#FFF",
                            fontWeight: "bold",
                            mt: 2,
                            px: 2,
                            '@media (min-width: 1636px)': {fontSize: '1.4rem'} 
                          }}>
              Cancel
            </Button>
          </Grid>
        </Box>
        </Slide>
      </Modal>
    </Box>
  );
}
const useStyles = makeStyles({
  Modal: {
    position: 'absolute',
    top: '15%',
    left: '40%',
    height: '68vh',
    transform: 'translate(-50%, -50%)',
    width: 350,
    backgroundColor: '#DB8829',
    boxShadow: 24,
    color:'#FFFFFF',
    borderRadius:30,
    padding: 20
    ,'@media (min-width: 1636px)': {height: '50vh',width: 400,} 
  }  
})
export default SelectModal;